<div class="avatar-container" [style.--avatar-size]="size">
  <ng-container *ngIf="pictureFullPath; else fallback">
    <img [utilsDisableImageCaching]="pictureFullPath" class="avatar-img" />
  </ng-container>

  <ng-template #fallback>
    <shared-ui-icons-icon [iconName]="iconType.User" class="default-avatar-icon"> </shared-ui-icons-icon>
  </ng-template>
</div>
